/**
 * 신규발주 — 발주할 기사 선택 (협력사 팝업 /p/orders/new). 레거시 public/scs/manage_pop_svc_neworder.php 대체.
 * ($j.Pages.Partner.OrderNew / body data-page-type="Partner" data-page-name="OrderNew")
 *
 * 기사를 고르면 그 회원으로 대리로그인(/m/login/proxy)하여 모바일웹 발주화면으로 넘어간다.
 */
export default class OrderNew {
    initialize() {
        // 지사 필터
        $('#gisaBtns').on('click', '.gbtn', function () {
            $('#gisaBtns .gbtn').removeClass('on');
            $(this).addClass('on');
            const sosok = $(this).data('sosok');
            $('#memTableList tbody tr').each(function () {
                const s = String($(this).data('sosok') || '');
                $(this).toggle(!sosok || s === String(sosok));
            });
        });

        // 기사 선택 → 대리로그인 후 발주화면
        $('#memTableList').on('click', '.sel-btn', function () {
            const mbNo = $(this).data('num');
            // 팝업이 아니라 부모창(오더목록)에서 발주화면을 열어야 자연스럽다
            const target = '/m/login/proxy?work_num=' + mbNo;
            if (window.opener && !window.opener.closed) {
                window.opener.location.href = target;
                window.close();
            } else {
                document.location.href = target;
            }
        });
    }
}
